import * as React from 'react'
import { clsx } from 'clsx'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  footer?: React.ReactNode
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, title, footer, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(
          'rounded-xl border border-neutral-200 dark:border-white/10 bg-white dark:bg-brand-900/70 p-4 shadow-sm dark:shadow-soft',
          className
        )}
        {...props}
      >
        {title && (
          <h3 className="text-neutral-900 dark:text-white text-lg font-semibold mb-2">{title}</h3>
        )}
        <div>{children}</div>
        {footer && (
          <div className="mt-4 pt-4 border-t border-neutral-200 dark:border-white/10">{footer}</div>
        )}
      </div>
    )
  }
)

Card.displayName = 'Card'

